export const useUserStore = defineStore('user', () => {
  const userDetail = ref({})
  const setUserDetail = (data) => {
    userDetail.value = data
  }

  return {
    userDetail,
    setUserDetail
  }
})
